import {
  IArchiveMaintenance,
  ICreateMaintenance,
  ICreateMaintenanceType,
  IUpdateMaintenance,
} from '@/interfaces/api/maintenance'
import ApiService from '../api.service'
import getCurrentCompanyId from '../company.service'

const MaintenanceResource = {
  getMaintenancePages: (
    page: number,
    items: number,
    sort: string,
    sort_direction: string,
    sensor_id: string,
    user_id: string,
    status: string,
    origim: string,
    priority: string,
    description: string,
    actions_taken: string,
    start_date: string,
    end_date: string,
    maintenance_type: string,
  ) =>
    ApiService.get(
      `/v1/companies/${getCurrentCompanyId()}/maintenances?page=${page}&items=${items}&sort=${sort}&sort_direction=${sort_direction}&sensor_id=${sensor_id}&user_id=${user_id}&status=${status}&origin=${origim}&priority=${priority}&description=${description}&actions_taken=${actions_taken}&start_date=${start_date}&end_date=${end_date}&maintenance_type_id=${maintenance_type}`,
    ),
  getMaintenanceTypes: () => ApiService.get(`/v1/maintenance_types`),
  createMaintenanceType: (params: ICreateMaintenanceType) => ApiService.post('/v1/maintenance_types', params),
  createMaintenance: (params: ICreateMaintenance) =>
    ApiService.post(`/v1/companies/${getCurrentCompanyId()}/maintenances`, params),
  getUserMaintenance: () => ApiService.get(`/v1/companies/${getCurrentCompanyId()}/maintenances/user_maintenances`),
  getMaintenance: (maintenanceId: number) =>
    ApiService.get(`/v1/companies/${getCurrentCompanyId()}/maintenances/${maintenanceId}`),
  updateMaintenance: (maintenance_id: number, params: IUpdateMaintenance) =>
    ApiService.put(`/v1/companies/${getCurrentCompanyId()}/maintenances/${maintenance_id}`, params),
  archiveMaintenance: (maintenanceId: number, params: IArchiveMaintenance = { archived: true }) =>
    ApiService.post(`/v1/companies/${getCurrentCompanyId()}/maintenances/${maintenanceId}/archive`, params),
  deleteMaintenance: (maintenanceId: number) =>
    ApiService.delete(`/v1/companies/${getCurrentCompanyId()}/maintenances/${maintenanceId}`),
  getMaintenanceReport: (start_date: string, end_date: string) =>
    ApiService.get(
      `/v1/companies/${getCurrentCompanyId()}/maintenances/report?start_date=${encodeURIComponent(start_date)}&end_date=${encodeURIComponent(end_date)}`,
    ),
}

export default MaintenanceResource
